// v-reveal="delayMs": fades an element in when it scrolls into view
let observer = null

function reveal(el) {
  el.classList.add('is-revealed')
  // Drop the stagger delay once shown so hover transitions are not delayed
  setTimeout(() => {
    el.style.transitionDelay = ''
  }, (parseInt(el.style.transitionDelay, 10) || 0) + 900)
}

function getObserver() {
  if (!observer) {
    observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target)
            reveal(entry.target)
          }
        })
      },
      { rootMargin: '0px 0px -8% 0px' }
    )
  }
  return observer
}

export default {
  bind(el, binding) {
    el.classList.add('reveal')
    if (binding.value) {
      el.style.transitionDelay = `${binding.value}ms`
    }
  },
  inserted(el) {
    if (!('IntersectionObserver' in window)) {
      reveal(el)
      return
    }
    getObserver().observe(el)
  },
  unbind(el) {
    if (observer) {
      observer.unobserve(el)
    }
  }
}
